import { memo } from 'react';
import Button from './Button';

const BackButton = ({ onClick, disabled, children }) => (
  <Button
    variant="text"
    onClick={onClick}
    disabled={disabled}
    hasHover={false}
    hasActive={false}
    styles={{
      color: '#B5B5B5',
    }}>
    {children}
  </Button>
);

export default memo(BackButton);
